<script setup lang="ts">
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
</script>

<template>
	<header class="border-b border-n-100 py-24px">
		<div class="bs-container flex h-24px justify-center mdp:justify-start">
			<BaseIcon
				name="company_logo_primary"
				class="col-span-12 h-24px w-[156px] fill-o-500"
			/>
		</div>
	</header>
</template>
